import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from 'reactstrap'
import styled from 'styled-components'
import Select from 'react-select'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import mapKeys from 'lodash/mapKeys'
import DatePicker from 'react-datepicker'
import { FONTS, COLORS } from '../../../constants'

const ExportHeadcountForm = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'lobList')) !== JSON.stringify(prevState.lobList)) {
      const lobList = get(nextProps, 'lobList')
      const newLOBList = []
      lobList.map(lob => {
        const newLOB = mapKeys(lob, (value, key) => {
          return key === 'lob_name' ? 'label' : key
        })
        newLOBList.push(newLOB)
        return lob
      })
      set(tempState, 'lobList', newLOBList)
    }
    return tempState
  }

  state={ lobList: [] }

  render() {
    const { handleInputExport, clickExportButton } = this.props
    const { open } = this.props
    const { lobList } = this.state

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal isOpen={ open } toggle={ () => clickExportButton('cancel') }>
        <ModalHeader toggle={ () => clickExportButton('cancel') }>
          <HeadLabel>{ `Headcount Export` }</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <DetailLabel>Select LOB</DetailLabel>
              <SelectInputField
                placeholder={ 'Select LOB' }
                options={ orderBy(lobList, 'label', 'asc') }
                onChange={ (e) => handleInputExport('lob', e) }
                value={ get(this.props, 'selectedLOB') }
              />
              <RowMonth>
                <MonthContainer>
                  <DetailLabel>Start Month</DetailLabel>
                  <CustomDatePicker
                    autoComplete='off'
                    onChange={ (e) => handleInputExport('startDate', e) }
                    name="start_date"
                    placeholderText='DD/MM/YYYY'
                    selected={ get(this.props, 'selectedStartMonth') }
                    dateFormat="DD/MM/YYYY"
                    showYearDropdown
                    showMonthDropdown
                  />
                </MonthContainer>
                <MonthContainer>
                  <DetailLabel>End Month</DetailLabel>
                  <CustomDatePicker
                    autoComplete='off'
                    onChange={ (e) => handleInputExport('endDate', e) }
                    name="end_date"
                    placeholderText='DD/MM/YYYY'
                    selected={ get(this.props, 'selectedEndMonth') }
                    dateFormat="DD/MM/YYYY"
                    showYearDropdown
                    showMonthDropdown
                  />
                </MonthContainer>
              </RowMonth>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <FooterButton
            color='success'
            onClick={ () => clickExportButton('export') }
            disabled={ get(this.props, 'selectedLOB.length') === 0 }
          >Export
          </FooterButton>
        </ModalFooter>
      </Modal>
    )
  }
}

ExportHeadcountForm.propTypes = {
  open: PropTypes.bool,
  handleInputExport: PropTypes.func,
  clickExportButton: PropTypes.func,
}
ExportHeadcountForm.defaultProps = {
  open: false,
  handleInputExport: () => {},
  clickExportButton: () => {},
}
export default ExportHeadcountForm

const CustomDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  max-width: 100px;
  height: 30px;
  padding-left: 5%;
  border-radius: 5px;
  border: ${props => {
    const status = props.selected
    if (status === '' || status === null) {
      return '1px solid #D9534F'
    }
    return '1px solid #CCCCCC'
  }};
`
const RowMonth = styled.div`
  display: flex;
  flex-direction: row;
`
const DetailLabel = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-top: 10px;
`
const HeadLabel = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const FooterButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const SelectInputField = styled(Select)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width : 100%;
  margin-top: 5px;
`
const MonthContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  margin-right: 20px;
  input{
    min-width: 100px !important;
    max-height: 30px !important;
    min-height: 30px !important;
    font-size: 12px !important;
  }
  .calendar-container {
    font-family: 'Gotham' !important;
    width: 200px !important;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    border: 2px solid #eee;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .col_mp:hover{
    background-color: #AD2624 !important;
  }
  .selected_date_mp{
    font-size:12px !important;
    color: #1A1A17 !important;
  }
  .selected_cell {
    font-family: 'Gotham-Bold' !important;
    background-color: #AD2624 !important;
  }
  .arrows_mp{
    font-weight: lighter !important;
    font-size: 12px !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/report/form/export-headcount.js